// extracted by mini-css-extract-plugin
export default {"empty":"Students_empty__+Ij-7"};